import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

const baseUri = '/api/aggregator/cqgaccounts/v1'

export type GetSsoUsersByTenantRequest = {
  tenantId: string
  skip?: number
  take?: number
}

export type CreateSsoUserRequest = {
  tenantId: string
  username: string
  cqgExperience: CqgExperience
}

export type UpdateSsoUserRequest = {
  tenantId: string
  id: string
  username?: string
  cqgExperience?: CqgExperience
}

export type DeleteSsoUserRequest = {
  tenantId: string
  id: string
}

function getTenantHeaders(tenantId: string) {
  return {
    'X-Bushel-Tenant': tenantId,
    'Content-Type': 'application/json',
  }
}

export function GetSsoUsersByTenant({ tenantId, skip = 0, take = 50 }: GetSsoUsersByTenantRequest) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/GetSsoUsersByTenant`,
      {
        skip,
        take,
      },
      {
        headers: getTenantHeaders(tenantId),
      }
    )
  )
}

export function CreateSsoUser({ tenantId, ...data }: CreateSsoUserRequest) {
  return tryQuery(
    bidlClient.post(`${baseUri}/CreateSsoUser`, data, {
      headers: getTenantHeaders(tenantId),
    })
  )
}

export function UpdateSsoUser({ tenantId, ...data }: UpdateSsoUserRequest) {
  return tryQuery(
    bidlClient.post(`${baseUri}/UpdateSsoUser`, data, {
      headers: getTenantHeaders(tenantId),
    })
  )
}

export function DeleteSsoUser({ tenantId, id }: DeleteSsoUserRequest) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/DeleteSsoUser`,
      {
        id,
      },
      {
        headers: getTenantHeaders(tenantId),
      }
    )
  )
}
